export default __webpack_public_path__ + "static/media/panda.04a18f2a.png";